import React from "react";
import { Home, Users, Activity, User } from "lucide-react";

const tabs = [
  { id: "home", label: "Home", icon: Home },
  { id: "circle", label: "Circle", icon: Users },
  { id: "activity", label: "Activity", icon: Activity },
  { id: "profile", label: "Profile", icon: User },
];

export default function BottomNav({ active, onChange }) {
  return (
    <div
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] h-[88px] bg-white/95 backdrop-blur border-t border-sand-200 px-4 pb-4 pt-2 flex items-stretch justify-between z-40"
      data-testid="bottom-nav"
    >
      {tabs.map((t) => {
        const Icon = t.icon;
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            onClick={() => onChange(t.id)}
            data-testid={`bottom-nav-${t.id}`}
            className="flex-1 flex flex-col items-center justify-center gap-1 group"
          >
            <div
              className={`h-9 w-14 rounded-full flex items-center justify-center transition-all
                ${isActive ? "bg-sage-50 text-sage-600" : "text-ink-500 group-active:bg-sand-100"}`}
            >
              <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
            </div>
            <span className={`text-[11px] tracking-wide ${isActive ? "text-sage-700 font-semibold" : "text-ink-500"}`}>
              {t.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
